import { ODATA_BASE } from "./api_config";

/**
 * OData $metadata'ya bakip bir alanin API tarafindan taninip taninmadigini soyler.
 *
 * Neden gerekli: API bilmedigi bir alan POST/PATCH edilirse HTTP 500 donuyor.
 * Veritabanina kolon eklenmis olsa bile, .NET projesi yeniden derlenip
 * yayinlanana kadar alan API'de yok. Bu yuzden panel alani ancak
 * desteklendiginde gonderiyor.
 */
let _metadataText = null;
let _fetchedAt = 0;
const TTL_MS = 10 * 60 * 1000;

export async function odataSupportsField(fieldName) {
  try {
    if (!_metadataText || Date.now() - _fetchedAt > TTL_MS) {
      const rsp = await fetch(`${ODATA_BASE}/$metadata`, {
        headers: { Accept: "application/xml" },
      });
      _metadataText = await rsp.text();
      _fetchedAt = Date.now();
    }
    return _metadataText.indexOf(fieldName) !== -1;
  } catch (e) {
    return false;
  }
}

/** Desteklenmeyen alanlari payload'dan temizler */
export async function stripUnsupportedFields(payload, fieldNames) {
  const out = { ...payload };
  for (const f of fieldNames) {
    // eslint-disable-next-line no-await-in-loop
    if (!(await odataSupportsField(f))) delete out[f];
  }
  return out;
}
